import { useEffect, useCallback } from "react";
import debounce from "lodash/debounce";
import { actions } from "../store/app";
import { useDispatch, useStore } from "../store";
import { checkIsDesktop } from "../util/viewport-utils";

const useViewportController = () => {
  const dispatch = useDispatch();
  const {
    app: { isDesktop },
  } = useStore();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResize = useCallback(
    debounce(() => {
      if (checkIsDesktop()) {
        isDesktop || dispatch(actions.setViewport(true));
      } else {
        isDesktop && dispatch(actions.setViewport(false));
      }
    }, 300),
    [isDesktop]
  );

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);
};

export default useViewportController;
